<template>
  <div v-if="data === null" class="loading" style="min-height: 100px">
    <b-spinner label="Loading..."></b-spinner>
  </div>
  <!-- 空狀態的樣式比照站上其他頁面（首頁型錄、帳單、歷史訂單），
       置中、主色、留白，不要用預設的小字靠左段落 -->
  <div v-else-if="data.total === 0"
       class="text-main-color font-weight-500 text-center font-size-18 py-5">
    {{ empty_text }}
  </div>
  <div v-else>
    <div v-for="(item,index) in data.items" :key="index">
      <main>
        <slot :item="item" :index="index"></slot>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListDataLoadingWidget",
  props: {
    empty_text: {
      type: String,
      default: () => '尚無資料',
    },
    data: Object,
  },
}
</script>

<style scoped>
</style>
